export default function translate(text, obj) {
  if (obj !== undefined) {
    if (obj.count) return translatePlural(text, obj);

    return window.Translator.trans(text, obj);
  }

  return window.Translator.trans(text);
}

export const t = (key, values) => translate(`holidayFinder.${key}`, { ...values });

function translatePlural(text, obj) {
  return window.Translator.transChoice(text, obj.count, obj);
}
